// Module
var code = "<mn-medical-file patient=\"vm.currentPatient\" class=\"md-padding\"></mn-medical-file>";
// Exports
module.exports = code;